import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";

import RoutesFile from "./RoutesFile";
import "./App.css";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkScreen();

    window.addEventListener("resize", checkScreen);

    return () => {
      window.removeEventListener("resize", checkScreen);
    };
  }, []);

  return (
    <>
      <Toaster
        position={isMobile ? "top-center" : "top-right"}
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#1e1e1e",
            color: "#ffffff",
            borderRadius: "8px",
          },
        }}
      />

      <RoutesFile />
    </>
  );
}

export default App;